import jfetch from '@jontetz/jfetch';

export function getCountries() {
    return jfetch.get(`/api/locale/countries`);
}

export function getStatesByCountryId(id) {
    return jfetch.get(`/api/locale/statesbycountry?countryid=${id}`);
}

export function getSupportedCountries() {
    return jfetch.get(`/api/locale/supportedcountries`);
}